export const Seaticon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.33331 2.42033V8.837H11.6666V2.42033H2.33331ZM1.16665 1.84108C1.16665 1.51675 1.43206 1.25366 1.74531 1.25366H12.2546C12.5743 1.25366 12.8333 1.51558 12.8333 1.84108V10.0037H1.16665V1.84108ZM0.583313 10.587H13.4166V11.7537H0.583313V10.587Z"
                fill="currentColor"
            />
        </svg>
    );
};
